import { cn } from '@/shared/utils/cn'

interface SectionCardProps {
  title?: string
  children: React.ReactNode
  className?: string
}

export function SectionCard({ title, children, className }: SectionCardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-ue-border-medium bg-ue-bg-darker p-4',
        className
      )}
    >
      {title && (
        <h3 className="mb-3 text-xs font-semibold uppercase tracking-wider text-ue-text-secondary">
          {title}
        </h3>
      )}
      {children}
    </div>
  )
}
